<template lang="pug">
a(:href='pageUrl' target="_blank") {{ $t('menu.privacy') }}
</template>

<script>
export default {
	computed: {
		pageUrl() {
			if (this.$route.params.language) {
				return '/' + this.$route.params.language + '/privacy'
			}

			return '/privacy'
		}
	}
}
</script>
